<template>
  <div>
    <div v-if="weather && current_user">
      <v-layout row wrap>
        <v-flex sm4></v-flex>
        <v-flex sm2 @click="weather_modal = true">
          <v-img :src="weather_icon_stg" height="24" contain/>
        </v-flex>
        <v-flex
          sm6
          class="text-md-center subheading pointer"
          @click="weather_modal = true"
        >{{ weather.location + ': '+ weather.weather.current_temp }}°</v-flex>
      </v-layout>
      <v-dialog v-model="weather_modal" max-width="900">
        <v-card>
          <v-flex right>
            <v-icon medium @click="weather_modal = false">close</v-icon>
          </v-flex>
          <v-layout>
            <v-flex>
              <br>
              <v-card flat>
                <v-img :src="weather_icon_stg" height="100" contain/>
                <v-card-title>
                  <v-flex>
                    <h3 class="text-md-center headline mb-2">Hoy</h3>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Actual: ' + weather.weather.current_temp }}°</p>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Mínima:' + weather.weather.min_temp }}°</p>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Máxima:' + weather.weather.max_temp }}°</p>
                  </v-flex>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card flat>
                <v-img :src="weather_icon_tmrr_stg" height="100" contain/>
                <v-card-title>
                  <v-flex>
                    <h3 class="text-md-center headline mb-2">{{current_user.tomorrow}}</h3>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Mínima:' + weather.weather.tomorrow_min }}°</p>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Máxima:' + weather.weather.tomorrow_max }}°</p>
                  </v-flex>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card flat>
                <v-img :src="weather_icon_after_tmrr_stg" height="100" contain/>
                <v-card-title>
                  <v-flex>
                    <h3 class="text-md-center headline mb-2">{{current_user.tomorrow_1}}</h3>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Mínima:' + weather.weather.after_tomorrow_min }}°</p>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Máxima:' + weather.weather.after_tomorrow_max }}°</p>
                  </v-flex>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card flat>
                <v-img :src="weather_icon_aa_tmrr_stg" height="100" contain/>
                <v-card-title>
                  <v-flex>
                    <h3 class="text-md-center headline mb-2">{{current_user.tomorrow_2}}</h3>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Mínima:' + weather.weather.aa_tomorrow_min }}°</p>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Máxima:' + weather.weather.aa_tomorrow_max }}°</p>
                  </v-flex>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card flat>
                <v-img :src="weather_icon_aaa_tmrr_stg" height="100" contain/>
                <v-card-title>
                  <v-flex>
                    <h3 class="text-md-center headline mb-2">{{current_user.tomorrow_3}}</h3>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Mínima:' + weather.weather.aaa_tomorrow_min }}°</p>
                    <p
                      class="text-md-center subheading"
                    >{{ 'Máxima:' + weather.weather.aaa_tomorrow_max }}°</p>
                  </v-flex>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-layout justify-end>
        <v-flex sm9 class="text-md-right subheading">
          <div>No hay datos. Seleccionar ciudad</div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import axios from "axios";
import { mapActions, mapState, mapGetters } from "vuex";
let data = [];
export default {
  data() {
    return {
      data: data,
      weather_modal: false,
    };
  },
  computed: {
    ...mapState("weather", ["weather"]),
    ...mapState("user", ["current_user"]),
    weather_icon_stg: function() {
      return require(`@/assets/weather/` +
        this.weather.weather.icon +
        `.svg`);
    },
    weather_icon_tmrr_stg: function() {
      return require(`@/assets/weather/` +
        this.weather.weather.tomorrow_icon +
        `.svg`);
    },
    weather_icon_after_tmrr_stg: function() {
      return require(`@/assets/weather/` +
        this.weather.weather.after_tomorrow_icon +
        `.svg`);
    },
    weather_icon_aa_tmrr_stg: function() {
      return require(`@/assets/weather/` +
        this.weather.weather.aa_tomorrow_icon +
        `.svg`);
    },
    weather_icon_aaa_tmrr_stg: function() {
      return require(`@/assets/weather/` +
        this.weather.weather.aaa_tomorrow_icon +
        `.svg`);
    }
  },
  methods: {
    ...mapActions("weather", ["fetchWeather"]),
  },
  mounted(){
    this.fetchWeather(config.USER_ID); 
  },
};
</script>
<style >
.weather_position {
  margin-top: -5px;
}
.pointer {
  cursor: pointer;
}
</style>
